<template>
    <validation-provider
        :name="label"
        :vid="vid"
        :rules="rules"
        v-if="is_loaded && hasFields"
        slim
    >
        <b-card
            class="my-2"
            header-class="d-flex w-100 justify-content-between align-items-center"
        >
            <template #header>
                <h6 class="mb-1">
                    {{ title }}
                </h6>
            </template>

            <form-set-generic
                v-model="internalValue"
                name="curriculum.computing"
                form="curriculum"
                section="computing"
                :fields="internalFields"
                :domains="['computing']"
                v-if="hasFields"
                autocomplete="off"
            >
                <template #basic="{model, field, componentName, testId, component}">
                    <component
                        ref="field-basic"
                        :is="component.is"
                        :name="componentName"
                        :test-id="testId"
                        v-model="model[field]"
                        v-bind="component"
                        :options="computerKnowledgesOptions"
                        autocomplete="off"
                        :reduce="(option) => option.value || option"
                    >
                        <template #no-options="{ search, searching }">
                            <span v-if="isLoadingComputerKnowledges">{{ $t("common.loading") }}...</span>
                            <span v-else-if="searching">
                                {{ `${$t("common.computing_knowledge_not_found")} "${search}"` }}.
                                <a href="#" @click.prevent="addComputerKnowledges(search)">
                                {{ $t("common.click") }}
                                </a>
                                {{ $t("common.to_add") }}
                            </span>
                            <span v-else>
                                {{ $t("common.no-results-found") }}
                            </span>
                        </template>

                    </component>
                </template>
                <template #intermediate="{model, field, componentName, testId, component}">
                    <component
                        ref="field-intermediate"
                        :is="component.is"
                        :name="componentName"
                        :test-id="testId"
                        v-model="model[field]"
                        v-bind="component"
                        :options="computerKnowledgesOptions"
                        autocomplete="off"
                        :reduce="(option) => option.value || option"
                    >
                        <template #no-options="{ search, searching }">
                            <span v-if="isLoadingComputerKnowledges">{{ $t("common.loading") }}...</span>
                            <span v-else-if="searching">
                                {{ `${$t("common.computing_knowledge_not_found")} "${search}"` }}.
                                <a href="#" @click.prevent="addComputerKnowledges(search)">
                                {{ $t("common.click") }}
                                </a>
                                {{ $t("common.to_add") }}
                            </span>
                            <span v-else>
                                {{ $t("common.no-results-found") }}
                            </span>
                        </template>
                    </component>
                </template>
                <template #advanced="{model, field, componentName, testId, component}">
                    <component
                        ref="field-Advanced"
                        :is="component.is"
                        :name="componentName"
                        :test-id="testId"
                        v-model="model[field]"
                        v-bind="component"
                        :options="computerKnowledgesOptions"
                        autocomplete="off"
                        :reduce="(option) => option.value || option"
                    >
                        <template #no-options="{ search, searching }">
                            <span v-if="isLoadingComputerKnowledges">{{ $t("common.loading") }}...</span>
                            <span v-else-if="searching">
                                {{ `${$t("common.computing_knowledge_not_found")} "${search}"` }}.
                                <a href="#" @click.prevent="addComputerKnowledges(search)">
                                {{ $t("common.click") }}
                                </a>
                                {{ $t("common.to_add") }}
                            </span>
                            <span v-else>
                                {{ $t("common.no-results-found") }}
                            </span>
                        </template>
                    </component>
                </template>
            </form-set-generic>
        </b-card>
    </validation-provider>
</template>

<script>
import * as _ from 'lodash-es'
import FormSetGeneric from '@components/forms/set/Generic.vue'
import FormFieldBase from "./../mixins/Base.js";
import FormFieldSet from "./../mixins/Set.js";
import { ValidationProvider } from "vee-validate";
import { useDomain } from "@state/domain/domain";

export default {

    mixins : [FormFieldBase, FormFieldSet],
    components: {
        ValidationProvider,
        FormSetGeneric
    },
    data() {
        return {
            computerKnowledgesOptions: [],
            isLoadingComputerKnowledges: false,
        };
    },
    created() {
        this.domain = useDomain();
        
        this.computerKnowledgesOptions = this.domain.computing || [];  
        //TODO: buscar customizado e dar um push na arquitetura domains

    },
    methods : {
        addComputerKnowledges(name) {     
            this.domain.create_record("computing", { label: name })
                .then(
                    this.domain = useDomain()
                );
                
        }
    }
};
</script>
